import React, { memo } from 'react'
import { Box } from '@mui/material'

import Text from '../text/Text'
import CustomLinearProgress from './CustomLinearProgress'

const MilestoneProgress = ({ completed, start, end, rootSx }) => {
  return (
    <Box sx={{ width: '100%', mb: 1, mt: 1, ...rootSx }}>
      <Box
        display='flex'
        alignItems='center'
        sx={{
          pb: '5px'
        }}
      >
        <Text label={start} sx={{ fontSize: 18 }} />
        <Box
          sx={{
            ml: 'auto',
            textAlign: 'right'
          }}
        >
          <Text label={end} sx={{ fontSize: 18 }} />
        </Box>
      </Box>
      <CustomLinearProgress value={completed} size={20} />
    </Box>
  )
}

export default memo(MilestoneProgress)
